<!--
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-23 08:24:17
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 08:29:42
 * @FilePath: /unified-development-platform/src/components/move-path/shared/NameInput.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
export default {
  name: 'NameInput',
  props: {
    value: [String, Number],
    showWordLimit: {
      default: true,
      type: Boolean
    },
    maxLength: {
      default: '64',
      type: [String, Number]
    }
  },
  methods: {
    inputChange(val) {
      this.$emit('input', val);
    }
  }
};
</script>
<template>
  <el-input
    v-bind="$attrs"
    :value="value"
    :show-word-limit="showWordLimit"
    :maxlength="maxLength"
    v-on="$listeners"
    @input="inputChange($event)"
  />
</template>
